import {types} from 'mobx-state-tree';

const CategoryModel = types
    .model('CategoryModel', {
      key: types.string,
      name: types.string,
    });

export default CategoryModel;
